/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GameMoneyInvoiceResponse } from '../models/GameMoneyInvoiceResponse';
import type { SkfWalletResponse } from '../models/SkfWalletResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RefillService {
    /**
     * Get or create crypto deposit wallet address
     * Retrieves the user's deposit wallet address for the specified cryptocurrency.
     *
     * **Key Features:**
     * - **Automatic Creation**: If no wallet exists, one is created instantly and returned
     * - **Immediate Response**: Returns actual wallet address (no polling required)
     * - **Transaction History**: Includes the 10 most recent transactions
     * - **Idempotent**: Safe to call multiple times for the same currency
     *
     * **Supported Currencies**: BTC, ETH, LTC, USDC.ERC20, USDT.ERC20, and more.
     * Admin users have access to additional test currencies.
     *
     * @param currency Cryptocurrency symbol in uppercase format.
     *
     * **Examples:**
     * - `BTC` - Bitcoin
     * - `ETH` - Ethereum
     * - `USDC.ERC20` - USD Coin on Ethereum
     * - `USDT.ERC20` - Tether on Ethereum
     *
     * @returns any Wallet address and recent transactions retrieved or created successfully
     * @throws ApiError
     */
    public static getV1RefillCryptoDepositWallet(
        currency: string,
    ): CancelablePromise<{
        /**
         * Unique deposit wallet address for this user and currency
         */
        address: string;
        /**
         * Cryptocurrency symbol (matches request parameter)
         */
        currency: string;
        /**
         * Array of recent transactions (up to 10 most recent, ordered by creation date desc)
         */
        transactions: Array<{
            /**
             * Unique transaction identifier
             */
            id: string;
            /**
             * Transaction amount in cryptocurrency units (not fiat)
             */
            amount: string;
            /**
             * Numeric transaction status code:
             * - `10` - Waiting for confirmations
             * - `20` - Completed and credited
             * - `30` - Error or failed
             * - `40` - Refunded
             *
             */
            status: 10 | 20 | 30 | 40;
            /**
             * Number of blockchain confirmations received
             */
            confirmations: number;
            /**
             * Address that sent the transaction (if available)
             */
            senderAddress?: string | null;
            /**
             * Blockchain transaction hash (if available)
             */
            txHash?: string | null;
            /**
             * Transaction creation timestamp in ISO 8601 format
             */
            createdAt: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/refill/crypto/deposit/wallet/{currency}',
            path: {
                'currency': currency,
            },
            errors: {
                400: `Invalid request parameters`,
                401: `Authentication required`,
                429: `Rate limit exceeded`,
                500: `Internal server error during wallet creation`,
            },
        });
    }
    /**
     * Get Bitcoin wallet address
     * Retrieve the user's Bitcoin wallet address for deposits
     * @returns any Bitcoin wallet address retrieved successfully
     * @throws ApiError
     */
    public static getV1RefillCryptoBtcWallet(): CancelablePromise<{
        /**
         * Bitcoin wallet address
         */
        address?: string;
        /**
         * Cryptocurrency type (BTC)
         */
        coinType?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/refill/crypto/btc/wallet',
            errors: {
                404: `No Bitcoin wallet found for user`,
            },
        });
    }
    /**
     * Create Bitcoin wallet
     * Create a new Bitcoin wallet address for the user
     * @returns any Bitcoin wallet created successfully
     * @throws ApiError
     */
    public static postV1RefillCryptoBtcWallet(): CancelablePromise<{
        /**
         * Bitcoin wallet address
         */
        address?: string;
        /**
         * Cryptocurrency type (BTC)
         */
        coinType?: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/refill/crypto/btc/wallet',
            errors: {
                400: `Wallet creation failed or already in progress`,
            },
        });
    }
    /**
     * Deposit Steam wallet code
     * Process Steam wallet code for account balance refill
     * @param requestBody
     * @returns any Wallet code processed successfully
     * @throws ApiError
     */
    public static postV1RefillSteamWallet(
        requestBody: {
            /**
             * Steam wallet code (e.g., XXXXX-XXXXX-XXXXX)
             */
            walletCode: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/refill/steam-wallet',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid wallet code or processing error`,
            },
        });
    }
    /**
     * Redeem SKINWHALES gift card
     * Redeem SKINWHALES gift card code (purchased from Kinguin or other retailers) for account balance credit
     * @param requestBody
     * @returns SkfWalletResponse Gift card redeemed successfully, balance credited
     * @throws ApiError
     */
    public static postV1RefillSkfWallet(
        requestBody: {
            /**
             * Gift card code in format XXXXXX-XXXX-XXXXXX-XXXX
             */
            walletCode: string;
        },
    ): CancelablePromise<SkfWalletResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/refill/skf-wallet',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid or already used gift card code`,
            },
        });
    }
    /**
     * Create GameMoney payment invoice
     * Generate payment URL for GameMoney deposit
     * @param requestBody
     * @returns GameMoneyInvoiceResponse Payment URL created successfully
     * @throws ApiError
     */
    public static postV1RefillGmInvoice(
        requestBody: {
            /**
             * Amount to deposit in USD
             */
            amount: number;
        },
    ): CancelablePromise<GameMoneyInvoiceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/refill/gm-invoice',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
